import { useEffect, useRef } from "react";

import { subscribeHubLiveCacheChannels } from "./hubLiveBroker";
import type { HubCacheSseEvent } from "./hubCacheChannels";

export type UseHubCacheStreamOptions = {
  channels: readonly string[];
  enabled?: boolean;
  /** Restarts the authenticated stream when the owning user/session generation changes. */
  connectionKey?: string | null;
  onEvent: (event: HubCacheSseEvent) => void;
};

export { shouldInvalidateAllQueriesOnHubCacheReconnect } from "./useHubCacheStreamReconnectPolicy";

/**
 * Subscribe to hub-cache events on the browser-wide live socket.
 * Reconnect does not invalidate all React Query caches.
 */
export function useHubCacheStream(options: UseHubCacheStreamOptions): void {
  const onEventRef = useRef(options.onEvent);
  onEventRef.current = options.onEvent;
  const channelsKey = options.channels.join("\u0000");

  useEffect(() => {
    if (options.enabled === false || options.channels.length === 0) {
      return;
    }
    return subscribeHubLiveCacheChannels({
      channels: options.channels,
      onEvent: (event) => {
        onEventRef.current(event);
      },
    });
  }, [channelsKey, options.connectionKey, options.enabled]);
}
